import { QUIZZES_IMAGE_PATH } from '@lib/constants/quizzes'
import classNames from 'classnames'
import { Dispatch, SetStateAction } from 'react'
import ArenaButton from '@components/quizzes/arena/problems/arena-button'
import { ArrowRight } from 'react-feather'

type Props = {
  isBackgroundMusicOn: boolean
  setIsBackgroundMusicOn: Dispatch<SetStateAction<boolean>>
  isPaused: boolean
  setIsPaused: Dispatch<SetStateAction<boolean>>
  areProblemNavigationButtonsShown: boolean
  isBackButtonDisabled: boolean
  handlePreviousProblemClick: () => void
  handleNextProblemClick: () => void
  onSubmit: () => void
  isSubmitButtonShown: boolean
}

const ProblemBottomNavbar = ({
  areProblemNavigationButtonsShown,
  handleNextProblemClick,
  handlePreviousProblemClick,
  isBackButtonDisabled,
  isBackgroundMusicOn,
  isPaused,
  setIsBackgroundMusicOn,
  setIsPaused,
  onSubmit,
  isSubmitButtonShown,
}: Props) => (
  <div className="mt-auto flex justify-between px-5 mb-3 select-none relative">
    <div className="grid grid-cols-2 gap-2">
      <ArenaButton
        image={`${QUIZZES_IMAGE_PATH}arena/buttons/music-${
          isBackgroundMusicOn ? 'on' : 'off'
        }.svg`}
        title={isBackgroundMusicOn ? 'Music on' : 'Music off'}
        onClick={() => setIsBackgroundMusicOn((prev) => !prev)}
      />
      <ArenaButton
        image={`${QUIZZES_IMAGE_PATH}arena/buttons/${
          isPaused ? 'play' : 'pause'
        }.svg`}
        title={isPaused ? 'Resume' : 'Pause'}
        onClick={() => setIsPaused((prev) => !prev)}
      />
    </div>

    {isSubmitButtonShown && !isPaused ? (
      <div className="flex space-x-2">
        <p
          className="flex items-center font-600 leading-tight ml-auto lg:mr-4"
          style={{ width: '7rem' }}
        >
          Select all the right answer(s)
        </p>
        <div className="flex justify-end items-center">
          <button
            className="btn btn-orange flex items-center justify-center lg:space-x-2 px-3 lg:px-6"
            onClick={onSubmit}
          >
            <span className="hidden lg:block">Submit</span>
            <ArrowRight />
          </button>
        </div>
      </div>
    ) : (
      areProblemNavigationButtonsShown &&
      !isPaused && (
        <div className={classNames('grid grid-cols-2')}>
          <ArenaButton
            image={`${QUIZZES_IMAGE_PATH}arena/buttons/back.svg`}
            title="Back"
            onClick={handlePreviousProblemClick}
            disabled={isBackButtonDisabled || !areProblemNavigationButtonsShown}
          />
          <ArenaButton
            image={`${QUIZZES_IMAGE_PATH}arena/buttons/next.svg`}
            title="Next"
            onClick={handleNextProblemClick}
            disabled={!areProblemNavigationButtonsShown}
          />
        </div>
      )
    )}
  </div>
)

export default ProblemBottomNavbar
